import React, { useEffect, useState, useContext } from "react";
import { CookieContext } from "./contexts/CookieContext";
import Matomo from "./utilities/Matomo";
import Header from "./components/Header";
import Section from "./components/Section";
import HtmlHeader from "./utilities/HtmlHeader";
import BackgroundImage from "./assets/bg/ballpen-blur-close-up-461077.jpg";
import Container from "react-bootstrap/Container";
import Accordion from "react-bootstrap/Accordion";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import MarkdownView from "react-showdown";
import { Link } from "react-router-dom";
import { KeyboardArrowDown } from "@material-ui/icons/";
import ButtonWithIcon from "./components/ButtonWithIcon";
import ButtonMarketing from "./components/ButtonMarketing";

const Products = () => {
  useEffect(() => {
    const apiUrl =
      process.env.NODE_ENV === "production"
        ? "https://api.hannes-volk.de/products/"
        : "http://localhost:3001/products/";
    const fetchProducts = async (signal) => {
      const results = await fetch(apiUrl, {
        signal: signal,
      });
      const data = await results.json();
      setProducts(data);
    };
    const abortController = new AbortController();
    const signal = abortController.signal;
    fetchProducts(signal);
    return function cleanup() {
      abortController.abort();
    };
  }, []);

  const [products, setProducts] = useState([]);

  const [cookies] = useContext(CookieContext);
  const trackShopLink = (title) => {
    if (cookies.performance) {
      Matomo.push(["trackGoal", 4]);
      Matomo.push(["trackEvent", "Shop Link Click", title, "Patreon"]);
    }
  };

  return (
    <>
      <HtmlHeader title="Produkte" />
      <Header title="Produkte" image={BackgroundImage} />
      <Section variant="light">
        <Container>
          <Row className="mb-4">
            <Col>
              <h2>Alle Produkte</h2>
            </Col>
          </Row>
          <Row>
            {products.map((product, index) => (
              <Col sm={12} className="mb-3" key={product.id || index}>
                {product.id && (
                  <Card className="h-100">
                    <Card.Body>
                      {product.title && (
                        <Card.Title>{product.title}</Card.Title>
                      )}
                      {product.content && (
                        <Accordion>
                          <Accordion.Toggle
                            as={ButtonWithIcon}
                            noPadding
                            icon={<KeyboardArrowDown />}
                            variant="link"
                            eventKey={`${product.id}`}
                          >
                            Beschreibung
                          </Accordion.Toggle>
                          <Accordion.Collapse
                            className="mt-2"
                            eventKey={`${product.id}`}
                          >
                            <MarkdownView markdown={product.content} />
                          </Accordion.Collapse>
                        </Accordion>
                      )}
                    </Card.Body>
                    {product.url && (
                      <Card.Footer>
                        <Row>
                          <Col className="d-flex justify-content-center">
                            <ButtonMarketing
                              as={Link}
                              noPadding
                              variant="link"
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() => trackShopLink(product.title)}
                              to={`//www.patreon.com${product.url}`}
                            >
                              Zum Produkt
                            </ButtonMarketing>
                          </Col>
                        </Row>
                      </Card.Footer>
                    )}
                  </Card>
                )}
              </Col>
            ))}
          </Row>
        </Container>
      </Section>
    </>
  );
};

export default Products;
